import { AppError } from "@/core/modules/appFault/objects/AppError";
import { config } from "@/core/modules/config/objects/Config";

export const catchAppError = (functionName: string | undefined, parameters: Record<string, unknown> | undefined, error: unknown): void => {
  if (error instanceof Error && config.app.appFaults.skip.includes((error as Error).message)) return;
  const appError: AppError = error instanceof AppError ? error : new AppError(error);
  appError.addToStack(functionName, parameters, error);
  throw appError;
};
